export default {
  All: 0,
  Choosed: 1,
  NotChoose: 2
};
